
export { IsOnboardingCompleted } from "/home/runner/work/capsicum/capsicum/libs/features/onboard/shared/src/feature/IsOnboardingCompleted.tsx"